var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%","overflow":"auto"}},_vm._l((_vm.DataList),function(item,idx){return _c('div',{key:item.id,staticClass:"rowitem",on:{"click":function($event){}}},[_c('div',{staticClass:"rowtitle"},[_vm._v(" "+_vm._s(item.title)+" ")]),_c('div',{staticClass:"rowdate"},[_vm._v(" "+_vm._s(item.cdate)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }